
import { FloatingFeature } from "@models";
import { 
  AbilityEffect,
  ConsumedResource,
  ItemLimitation,
  Spellbook,
  SpellLimitation,
  UpgradableNumber 
} from "@dndModels";
import { AbilityScoreExpandedType } from "@dndModels/Types";
import { ABILITY_SCORES_EXPANDED } from "@dndModels/Constants";

export class SpellcastingFeature extends FloatingFeature {
  ability: AbilityScoreExpandedType = "None";
  ability_selectable_key = "";
  table = "";
  level = 0; // Full, Half, Third, etc
  level_bonus = 0; // 1 for Artificer
  spell_list_ids: string[] = [];
  spell_list_selectable_key = "";
  knowledge_type: "Prepared" | "Known" | "Spellbook" = "Known";
  spellbook: Spellbook | null = null;
  // These can be increased through other features.
  cantrips_max: UpgradableNumber = new UpgradableNumber();
  spells_prepared: UpgradableNumber = new UpgradableNumber();
  // These can be granted through other features
  ritual_casting = true;
  focus = "";
  schools: string[] = [];
  
  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.ability = obj.ability ? obj.ability : "None";
      this.table = obj.table ? obj.table : "Spellcasting";
      this.level = obj.level ? obj.level : 0;
      this.level_bonus = obj.level_bonus ? obj.level_bonus : 0;
      this.spell_list_ids = obj.spell_list_ids ? obj.spell_list_ids : (obj.spell_list_id ? [obj.spell_list_id] : []);
      this.knowledge_type = obj.knowledge_type ? obj.knowledge_type : "Known";
      this.spellbook = obj.spellbook ? new Spellbook(obj.spellbook) : null;
      if (this.spellbook) {
        this.spellbook.supplies_spells = true;
      }
      if (obj.cantrips_max && obj.cantrips_max.base === undefined) {
        // Translate old set up to new
        this.cantrips_max = new UpgradableNumber();
        this.cantrips_max.base = +obj.cantrips_max;
      } else if (obj.cantrips_max) {
        this.cantrips_max = new UpgradableNumber(obj.cantrips_max);
      } else {
        this.cantrips_max = new UpgradableNumber();
      }
      if (obj.spells_prepared) {
        this.spells_prepared = new UpgradableNumber(obj.spells_prepared);
      } else if (obj.base_spell_count) {
        // Translate old set up to new
        this.spells_prepared = new UpgradableNumber();
        this.spells_prepared.base = +obj.base_spell_count;
        if (obj.spell_count_per_level) {
          this.spells_prepared.add_source_level_mult = +obj.spell_count_per_level;
        }
        if (obj.extra_prepared_from_ability) {
          this.spells_prepared.add_ability_scores = [obj.extra_prepared_from_ability];
          this.spells_prepared.add_ability_mod_mult = 1;
        }
      } else {
        this.spells_prepared = new UpgradableNumber();
      }
      this.ritual_casting = obj.ritual_casting !== undefined ? obj.ritual_casting : true;
      this.focus = obj.focus ? obj.focus : "";
      
      if (!ABILITY_SCORES_EXPANDED.includes(this.ability)) {
        this.ability = "None";
      }
      this.spell_list_selectable_key = obj.spell_list_selectable_key ? obj.spell_list_selectable_key : "";
      this.schools = obj.schools ? obj.schools : [];
      this.schools = this.schools.filter(o => o !== "Any");
      this.ability_selectable_key = obj.ability_selectable_key ? obj.ability_selectable_key : "";
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.ability = obj.ability ? obj.ability : "None";
  //     this.table = obj.table ? obj.table : "Spellcasting";
  //     this.level = obj.level ? obj.level : 0;
  //     this.level_bonus = obj.level_bonus ? obj.level_bonus : 0;
  //     this.spell_list_ids = obj.spell_list_ids ? obj.spell_list_ids : (obj.spell_list_id ? [obj.spell_list_id] : []);
  //     this.knowledge_type = obj.knowledge_type ? obj.knowledge_type : "Known";
  //     this.spellbook = obj.spellbook ? new Spellbook(obj.spellbook) : null;
  //     if (this.spellbook) {
  //       this.spellbook.supplies_spells = true;
  //     }
  //     if (obj.cantrips_max && obj.cantrips_max.base === undefined) {
  //       // Translate old set up to new
  //       this.cantrips_max = new UpgradableNumber();
  //       this.cantrips_max.base = +obj.cantrips_max;
  //     } else if (obj.cantrips_max) {
  //       this.cantrips_max = new UpgradableNumber(obj.cantrips_max);
  //     } else {
  //       this.cantrips_max = new UpgradableNumber();
  //     }
  //     if (obj.spells_prepared) {
  //       this.spells_prepared = new UpgradableNumber(obj.spells_prepared);
  //     } else if (obj.base_spell_count) {
  //       // Translate old set up to new
  //       this.spells_prepared = new UpgradableNumber();
  //       this.spells_prepared.base = +obj.base_spell_count;
  //       if (obj.spell_count_per_level) {
  //         this.spells_prepared.add_source_level_mult = +obj.spell_count_per_level;
  //       }
  //       if (obj.extra_prepared_from_ability) {
  //         this.spells_prepared.add_ability_scores = [obj.extra_prepared_from_ability];
  //         this.spells_prepared.add_ability_mod_mult = 1;
  //       }
  //     } else {
  //       this.spells_prepared = new UpgradableNumber();
  //     }
  //     this.ritual_casting = obj.ritual_casting !== undefined ? obj.ritual_casting : true;
  //     this.focus = obj.focus ? obj.focus : "";
      
  //     if (!ABILITY_SCORES_EXPANDED.includes(this.ability)) {
  //       this.ability = "None";
  //     }
  //     this.spell_list_selectable_key = obj.spell_list_selectable_key ? obj.spell_list_selectable_key : "";
  //     this.schools = obj.schools ? obj.schools : [];
  //     this.schools = this.schools.filter(o => o !== "Any");
  //     this.ability_selectable_key = obj.ability_selectable_key ? obj.ability_selectable_key : "";
  //   }
  // }

  toDBObj(): any {
    const db_obj = super.toDBObj();
    return {
      ...db_obj,
      ability: this.ability,
      ability_selectable_key: this.ability_selectable_key,
      table: this.table,
      level: this.level,
      level_bonus: this.level_bonus,
      spell_list_ids: this.spell_list_ids,
      spell_list_selectable_key: this.spell_list_selectable_key,
      knowledge_type: this.knowledge_type,
      spellbook: this.spellbook ? this.spellbook.toDBObj() : null,
      cantrips_max: this.cantrips_max.toDBObj(),
      spells_prepared: this.spells_prepared.toDBObj(),
      // base_spell_count: this.base_spell_count,
      // spell_count_per_level: this.spell_count_per_level,
      // extra_prepared_from_ability: this.extra_prepared_from_ability,
      ritual_casting: this.ritual_casting,
      focus: this.focus,
      schools: this.schools
    };
  }

  copy(copyMe: FloatingFeature, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    if (copyMe instanceof SpellcastingFeature || copyMe instanceof SpellInfusionsFeature) {
      this.safe_copy(copyMe);
    }
  }

  safe_copy(copyMe: SpellcastingFeature | SpellInfusionsFeature) {
    this.ability = copyMe.ability;
    this.ability_selectable_key = copyMe.ability_selectable_key;
    this.table = copyMe.table;
    this.level = copyMe.level;
    this.level_bonus = copyMe.level_bonus;
    this.spell_list_ids = copyMe.spell_list_ids;
    this.spell_list_selectable_key = copyMe.spell_list_selectable_key;
    this.spellbook = copyMe.spellbook;
    this.cantrips_max = copyMe.cantrips_max.clone();
    if (copyMe instanceof SpellcastingFeature) {
      this.knowledge_type = copyMe.knowledge_type;
      this.spells_prepared = copyMe.spells_prepared.clone();
    }
    this.ritual_casting = copyMe.ritual_casting;
    this.focus = copyMe.focus;
    this.schools = copyMe.schools;
  }

  clone(drop_ids = false): SpellcastingFeature {
    const new_obj = new SpellcastingFeature();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  get spell_count_per_level() {
    return this.spells_prepared.add_source_level_mult;
  }

  get extra_prepared_from_ability() {
    return this.spells_prepared.add_ability_scores;
  }

  get base_spell_count() {
    return this.spells_prepared.base;
  }
}

export class SpellInfusionsFeature extends FloatingFeature {
  ability: AbilityScoreExpandedType = "None";
  ability_selectable_key = "";
  table = "";
  level = 0; // Full, Half, Third, etc
  level_bonus = 0; // 1 for Artificer
  spell_list_ids: string[] = [];
  spell_list_selectable_key = "";
  spellbook: Spellbook = new Spellbook();
  // infusion_mik_id: string = "";
  // These can be increased through other features.
  cantrips_max: UpgradableNumber = new UpgradableNumber();
  max_infusions_per_item: UpgradableNumber = new UpgradableNumber();
  // These can be granted through other features
  ritual_casting = true;
  focus = "";
  schools: string[] = [];
  
  constructor(obj?: any) {
    super(obj);
    this.feature_type = "Spell Infusions";
    if (obj) {
      this.ability = obj.ability ? obj.ability : "None";
      if (!ABILITY_SCORES_EXPANDED.includes(this.ability)) {
        this.ability = "None";
      }
      this.table = obj.table ? obj.table : "Magister Spell Infusions";
      this.level = obj.level ? obj.level : 0;
      this.level_bonus = obj.level_bonus ? obj.level_bonus : 0;
      this.spell_list_ids = obj.spell_list_ids ? obj.spell_list_ids : [];
      this.spellbook = obj.spellbook ? new Spellbook(obj.spellbook) : new Spellbook();
      if (this.spellbook) {
        this.spellbook.supplies_spells = true;
      }
      if (obj.cantrips_max) {
        this.cantrips_max = new UpgradableNumber(obj.cantrips_max);
      }
      if (obj.max_infusions_per_item) {
        this.max_infusions_per_item = new UpgradableNumber(obj.max_infusions_per_item);
      }
      this.ritual_casting = obj.ritual_casting !== undefined ? obj.ritual_casting : true;
      this.focus = obj.focus ? obj.focus : "";
      this.spell_list_selectable_key = obj.spell_list_selectable_key ? obj.spell_list_selectable_key : "";
      this.schools = obj.schools ? obj.schools : [];
      this.ability_selectable_key = obj.ability_selectable_key ? obj.ability_selectable_key : "";
      // this.infusion_mik_id = obj.infusion_mik_id ? obj.infusion_mik_id : "";
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.ability = obj.ability ? obj.ability : "None";
  //     if (!ABILITY_SCORES_EXPANDED.includes(this.ability)) {
  //       this.ability = "None";
  //     }
  //     this.table = obj.table ? obj.table : "Magister Spell Infusions";
  //     this.level = obj.level ? obj.level : 0;
  //     this.level_bonus = obj.level_bonus ? obj.level_bonus : 0;
  //     this.spell_list_ids = obj.spell_list_ids ? obj.spell_list_ids : [];
  //     this.spellbook = obj.spellbook ? new Spellbook(obj.spellbook) : new Spellbook();
  //     if (this.spellbook) {
  //       this.spellbook.supplies_spells = true;
  //     }
  //     if (obj.cantrips_max) {
  //       this.cantrips_max = new UpgradableNumber(obj.cantrips_max);
  //     }
  //     if (obj.max_infusions_per_item) {
  //       this.max_infusions_per_item = new UpgradableNumber(obj.max_infusions_per_item);
  //     }
  //     this.ritual_casting = obj.ritual_casting !== undefined ? obj.ritual_casting : true;
  //     this.focus = obj.focus ? obj.focus : "";
  //     this.spell_list_selectable_key = obj.spell_list_selectable_key ? obj.spell_list_selectable_key : "";
  //     this.schools = obj.schools ? obj.schools : [];
  //     this.ability_selectable_key = obj.ability_selectable_key ? obj.ability_selectable_key : "";
  //     // this.infusion_mik_id = obj.infusion_mik_id ? obj.infusion_mik_id : "";
  //   }
  // }

  toDBObj(): any {
    const db_obj = super.toDBObj();
    return {
      ...db_obj,
      ability: this.ability,
      ability_selectable_key: this.ability_selectable_key,
      table: this.table,
      level: this.level,
      level_bonus: this.level_bonus,
      spell_list_ids: this.spell_list_ids,
      spell_list_selectable_key: this.spell_list_selectable_key,
      spellbook: this.spellbook ? this.spellbook.toDBObj() : null,
      cantrips_max: this.cantrips_max.toDBObj(),
      max_infusions_per_item: this.max_infusions_per_item.toDBObj(),
      // infusion_mik_id: this.infusion_mik_id,
      ritual_casting: this.ritual_casting,
      focus: this.focus,
      schools: this.schools
    };
  }

  copy(copyMe: FloatingFeature, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    if (copyMe instanceof SpellInfusionsFeature || copyMe instanceof SpellcastingFeature) {
      this.safe_copy(copyMe);
    }
  }

  safe_copy(copyMe: SpellInfusionsFeature | SpellcastingFeature) {
    this.ability = copyMe.ability;
    this.ability_selectable_key = copyMe.ability_selectable_key;
    this.table = copyMe.table;
    this.level = copyMe.level;
    this.level_bonus = copyMe.level_bonus;
    this.spell_list_ids = copyMe.spell_list_ids;
    this.spell_list_selectable_key = copyMe.spell_list_selectable_key;
    this.spellbook = copyMe.spellbook?.clone()??new Spellbook();
    this.cantrips_max = copyMe.cantrips_max.clone();
    if (copyMe instanceof SpellInfusionsFeature) {
      // this.infusion_mik_id = copyMe.infusion_mik_id;
      this.max_infusions_per_item = copyMe.max_infusions_per_item.clone();
    }
    this.ritual_casting = copyMe.ritual_casting;
    this.focus = copyMe.focus;
    this.schools = copyMe.schools;
  }

  clone(drop_ids = false): SpellInfusionsFeature {
    const new_obj = new SpellInfusionsFeature();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}

/**
 * This is used for Weapon and Armor Infusions, and also for Infusion Boons.
 * They have an item limit and a spell limit, and effects.
 * The effects get added to infusions that fit the appropriate limits.
 */
export class SpellInfusionExtraEffectsFeature extends FloatingFeature {
  type: "On Spell" | "On Attack" | "Reaction" = "On Spell";
  item_limit: ItemLimitation = new ItemLimitation();
  spell_limit: SpellLimitation = new SpellLimitation();
  potence_type = "None";
  effects: AbilityEffect[] = [];
  consumed_resource: ConsumedResource = new ConsumedResource();

  get resource_consumed() {
    return "Infusion";
  }
  
  constructor(obj?: any) {
    super(obj);
    this.feature_type = "Spell Infusion Extra Effects";
    if (obj) {
      this.type = obj.type ? obj.type : "On Spell";
      this.item_limit = obj.item_limit ? new ItemLimitation(obj.item_limit) : new ItemLimitation();
      this.spell_limit = obj.spell_limit ? new SpellLimitation(obj.spell_limit) : new SpellLimitation();
      this.effects = obj.effects ? obj.effects.map((o: any) => new AbilityEffect(o)) : [];
      this.consumed_resource = obj.consumed_resource ? new ConsumedResource(obj.consumed_resource) : new ConsumedResource();
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.type = obj.type ? obj.type : "On Spell";
  //     this.item_limit = obj.item_limit ? new ItemLimitation(obj.item_limit) : new ItemLimitation();
  //     this.spell_limit = obj.spell_limit ? new SpellLimitation(obj.spell_limit) : new SpellLimitation();
  //     this.effects = obj.effects ? obj.effects.map((o: any) => new AbilityEffect(o)) : [];
  //     this.consumed_resource = obj.consumed_resource ? new ConsumedResource(obj.consumed_resource) : new ConsumedResource();
  //   }
  // }

  toDBObj(): any {
    const db_obj = super.toDBObj();
    return {
      ...db_obj,
      type: this.type,
      item_limit: this.item_limit.toDBObj(),
      spell_limit: this.spell_limit.toDBObj(),
      effects: this.effects.map(o => o.toDBObj()),
      consumed_resource: this.consumed_resource.toDBObj()
    };
  }

  copy(copyMe: FloatingFeature, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    if (copyMe instanceof SpellInfusionExtraEffectsFeature) {
      this.safe_copy(copyMe);
    }
  }

  safe_copy(copyMe: SpellInfusionExtraEffectsFeature) {
    this.type = copyMe.type;
    this.item_limit = copyMe.item_limit.clone();
    this.spell_limit = copyMe.spell_limit.clone();
    this.effects = copyMe.effects.map(o => o.clone());
    this.consumed_resource = copyMe.consumed_resource.clone();
  }

  clone(drop_ids = false): SpellInfusionExtraEffectsFeature {
    const new_obj = new SpellInfusionExtraEffectsFeature();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}